var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProCtaGraphics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 56,
    viewBox: "0 0 343 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3241_36635)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 29.5,
    r: 84.5,
    fill: "#FEF2DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 16,
    fill: "#FEF2DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 10,
    r: 4,
    fill: "#FEF2DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 2.5,
    r: 7.5,
    fill: "#FEF2DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 56,
    r: 15,
    fill: "#FEF2DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 46,
    r: 5,
    fill: "#FEF2DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3241_36635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 56,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProCtaGraphics);
export default __webpack_public_path__ + "static/media/ProCTAGraphics.f1f0b44f.svg";
export { ForwardRef as ReactComponent };